import React from 'react';
import Button from '@grnhse/seedling/lib/azalea/components/button';
import t from 'shared/utils/translation';
import { SimulatedEmail } from './simulated_email';
import styled from 'styled-components';

export function ModalBody({ previewEmail, closePreviewModal }) {
  return (
    <React.Fragment>
      <ModalBodyDiv data-provides="simulated_email">
        <SimulatedEmail previewEmail={previewEmail} />
      </ModalBodyDiv>
      <Button
        hideBg
        onClick={closePreviewModal}
        style={{ float: 'right', marginTop: '15px' }}
      >
        {t('gdpr.consent_extension_email.action_close_preview')}
      </Button>
    </React.Fragment>
  );
}

export const ModalBodyDiv = styled.div`
  width: 581px;
  margin: 9px 19px 1px 19px;
`;
